import { useCallback, useEffect, useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { UserAccessRequestType } from 'entities/Users'
import { useSettingsContext } from 'pages/settings/context/settingsContext'
import { useMembersViewContext } from 'pages/settings/pages/members/pages/membersView/context/membersViewContext'
import { MembersTable } from 'pages/settings/pages/members/pages/membersView/ui/MembersTable/MembersTable'
import { getAccessRequestColumns } from 'pages/settings/pages/members/pages/membersView/ui/RequestsMembersTab/ui/getAccessRequestColumns'
import { getAccessRequestActions } from 'pages/settings/pages/members/pages/membersView/ui/RequestsMembersTab/ui/getAccessRequestActions'
import { requestsAccessActionConfig } from 'pages/settings/pages/members/pages/membersView/ui/RequestsMembersTab/lib/requestsAccessActionConfig'

export const SalesmsgAccessTab = observer(() => {
  const entities = useEntitiesContext()
  const settings = useSettingsContext()
  const { fetchCounts, requestsMembersStore } = useMembersViewContext()
  const { salesmsgAccessStore } = requestsMembersStore
  const {
    init,
    tableStore,
    loading,
    search,
    setSearch,
    dispose,
    loadData,
    itemsRows,
    scrollToTopTrigger,
    isReviewDisabledByInboxAccess,
    isGracePeriod,
  } = salesmsgAccessStore

  const onSuccess = useCallback(() => {
    loadData()
    fetchCounts()
  }, [])

  useEffect(() => {
    init()
    return dispose
  }, [])

  const columns = useMemo(() => getAccessRequestColumns(UserAccessRequestType.SalesmsgAccess), [])

  const rows = itemsRows.map((item) => {
    item.setActionsProps({
      ...requestsAccessActionConfig,
      actions: getAccessRequestActions(item, {
        entities,
        settings,
        onSuccess,
        isReviewDisabledByInboxAccess,
        isGracePeriod,
      }),
    })

    return item
  })

  return (
    <MembersTable
      setSearch={setSearch}
      search={search}
      emptyStateProps={{
        text: 'No Salesmsg access requests',
        noIcon: true,
      }}
      tableProps={{
        ariaLabel: 'SalesmsgAccessTable',
        rows,
        columns,
        loading,
        store: tableStore,
        pinnedColumnIds: ['fullName'],
        scrollToTOpTrigger: scrollToTopTrigger,
      }}
    />
  )
})
